import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CmsBlockResolver, CmsService } from "./services";

@NgModule({
	imports: [CommonModule],
	providers: [CmsService, CmsBlockResolver]
})
export class CmsModule {}
